/* eslint-disable jsx-a11y/label-has-associated-control */
import React from 'react';
import { Grid, makeStyles } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import Theme from '../ui/Theme';

const useStyles = makeStyles(() => ({
  mainDiv: {
    marginBottom: '10px',
    backgroundColor: Theme.palette.secondary.main,
    // backgroundColor: "white",
    maxHeight: '61%',
    height: '61%',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  required_field: {
    '&:after': {
      content: "' *'",
      color: '#F50000',
    },
  },
  popupLabels: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: '15px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    textTransform: 'uppercase',
    textAlign: 'left',
    marginTop: '9px',
    marginBottom: '9px',
  },
}));

export default function DateStep({ selectedStartDate, handleDateChange, selectedEndDate }) {
  const classes = useStyles();

  return (
    <div className={classes.mainDiv}>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} style={{ paddingLeft: '20px' }}>
          <div className={classes.popupLabels}>
            <label htmlFor="courseOverview" className={classes.required_field}>
              Start Date
            </label>
          </div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              placeholder="YYYY-MM-DD"
              value={selectedStartDate}
              InputProps={{
                disableUnderline: true,
                classes: {
                  input: 'date-field',
                },
              }}
              onChange={(date) => handleDateChange('startDate', date)}
              format="yyyy-MM-dd"
              style={{
                width: '95%',
                backgroundColor: 'white',
                height: '40px',
                borderRadius: 8,
                padding: '10px',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={12} sm={6}>
          <div className={classes.popupLabels}>
            <label htmlFor="courseOverview" className={classes.required_field}>
              End Date
            </label>
          </div>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              placeholder="YYYY-MM-DD"
              value={selectedEndDate}
              InputProps={{
                disableUnderline: true,
                classes: {
                  input: 'date-field',
                },
              }}
              onChange={(date) => handleDateChange('endDate', date)}
              format="yyyy-MM-dd"
              style={{
                width: '95%',
                backgroundColor: 'white',
                height: '40px',
                borderRadius: 8,
                padding: '10px',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
      </Grid>
    </div>
  );
}
